import { DESIGN } from 'constants/store.constants';
import { STATUS_LOADING } from 'constants/statuses.constants';

const selectDesignSlice = (state) => state[DESIGN];
export const selectConstructs = (state) => selectDesignSlice(state).constructs;
export const selectInsertSuggestions = (state) => selectDesignSlice(state).insertSuggestions;
export const selectDesignStatus = (state) => selectDesignSlice(state).status;
export const selectSuggestionIsLoading = (state) => selectDesignSlice(state).suggestionsStatus === STATUS_LOADING;
export const selectDesignIsLoading = (state) => selectDesignStatus(state) === STATUS_LOADING;
